import Modal from "./component/Modal";
import { hasOwn } from "@core/utility/utility";
import styles from "./saveSearch.module.scss";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import { getActiveUserOrganisation, getEmailAlertFrequency, saveSearchCall, updateEmailAlert, checkEmailAlert } from "./services";
import CheckboxSelect from "@shared/country-components/CheckboxSelect";
import { TeuArray, WeightArray, checkforFilters, main_dropdown_options, measurable_parameter_name, redirectionUrls, searchTypeCustomStyles } from "./utility";
import commaFormat from "@utils/commaFormat";
import ReactTooltip from "react-tooltip";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { upgradePlansDictionary } from "@core/dictionary/upgrade-plans";
import { getIntelUrl } from "@utils/intelUrl";
import { toast } from "react-toastify";
import LoaderImg from "@assets/images/loader.gif";
import { saveSearchButtonType } from "@utils/enum";
const TABENUM = {
  current: "current",
  shared: "shared",
};

const SaveSearch = (props) => {
  const tempVariable = props && props.searchString ? props.searchString.split("||").map((item, index) => (index === 0 ? item.split("|")[0] : " " + item.split("|")[0])) : [""];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEmailAlert, setIsEmailAlert] = useState(false);
  const [frequencyOptions, setFrequencyOptions] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [measurableParameter, setMeasurableParameter] = useState(null);
  const [alertEntity, setAlertEntity] = useState([]);
  const [saveSearchName, setSaveSearchName] = useState(!!props.selectedTempData && !!props.selectedTempData.search_name ? props.selectedTempData.search_name : tempVariable.join(","));
  const [totalAlerts, setTotalAlerts] = useState({});
  const [isGifAlert, setIsGifAlert] = useState(false);
  const [dateRangeOptions, setDateRangeOptions] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [shareUserOptions, setShareUserOptions] = useState([]);
  const [selectedShareUser, setSelectedShareUser] = useState([]);

  useEffect(() => {
    if (props.activeDateRange) {
      let options = props.activeDateRange;
      if (props.currentUserPlan.includes("advanced") || props.currentUserPlan.includes("pro")) {
        options = props.activeDateRange.filter((item) => item !== "All Data" && item !== "Last 3 Years" && !item?.includes("Custom"));
      } else {
        setSelectedDateRange({ label: props?.activeDateRange?.[props?.activeDateRange?.length - 1], value: props?.activeDateRange?.[props?.activeDateRange?.length - 1] });
      }
      if (props.currentUserPlan.includes("pro")) {
        options = options.filter((item) => item !== "Last 2 Years");
      }
      options = options.map((item) => ({ value: item, label: item }));
      setDateRangeOptions(options);
    }
    if (props.savedSearchShow) {
      handleModalOpen();
    }
    if (props.isDashboard) {
      setIsEmailAlert(true);
    }
  }, []);
  const handleModalOpen = async () => {
    setLoading(true);
    setIsModalOpen(true);
    setSaveSearchName(props?.selectedTempData?.search_name || tempVariable.join(","));
    if (props.clearNudgePopupTimer) props.clearNudgePopupTimer();
    const { redirectionHsCodeValue } = props;
    const eventName = !!redirectionHsCodeValue && redirectionHsCodeValue.length >= 0 ? trackingEventDictionary.hsCodeRedirectionShipmentsPageSaveSearch : trackingEventDictionary.ShipmentsPageSaveSearch;
    trademoTrackingEvents(eventName, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
    try {
      await getEmailAlertFrequencyHandler();
      await checkEmailAlertHandler();
      await getActiveUsers();
    } catch (err) {
      toast.error("Something went wrong. Please try again later !!!");
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = (type = "") => {
    if (props.handleClose) {
      props.handleClose();
      setStep(1);
    } else {
      if (step === 2 && type === "Set Email Alert") {
        trademoTrackingEvents(trackingEventDictionary.shipmentsPageSaveSearchSetEmailAlert, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
        setStep(1);
        setIsEmailAlert(true);
      } else {
        setSaveSearchName(false);
        setIsEmailAlert(false);
        setFrequency(null);
        setStep(1);
        setIsModalOpen(false);
      }

      const { redirectionHsCodeValue } = props;
      const closeButtonType = typeof type === "string" ? type.toLowerCase() : "";
      if (!!redirectionHsCodeValue && redirectionHsCodeValue.length >= 0 && saveSearchButtonType[closeButtonType]) {
        trademoTrackingEvents(trackingEventDictionary.hsCodeRedirectionShipmentsPageSaveSearchCancel, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
      }
    }
  };

  const getEmailAlertFrequencyHandler = async () => {
    const { result, measurable_parameters, frequency } = await getEmailAlertFrequency({ redirectionId: props.redirectionId });
    setFrequencyOptions(result);
    setFrequency(props?.selectedTempData?.frequency ? props.selectedTempData.frequency : frequency ? frequency : result[props.redirectionId]?.alert_type?.[0].value);
    setMeasurableParameter(props?.selectedTempData?.measurable_parameters ? props.selectedTempData.measurable_parameters : measurable_parameters ? [measurable_parameters] : result[props.redirectionId] && result[props.redirectionId].measurable_parameters && result[props.redirectionId].measurable_parameters[0] ? [result[props.redirectionId].measurable_parameters[0]] : []);
    setAlertEntity(props.selectedTempData && props.selectedTempData.alert_entity && result[props.redirectionId] && result[props.redirectionId].analytics_keys ? props.selectedTempData.alert_entity.map((item) => ({ value: item, label: result[props.redirectionId].analytics_keys[item] })) : []);
  };

  const checkEmailAlertHandler = async () => {
    const { totalAlerts, is_gif_alert } = await checkEmailAlert();
    setTotalAlerts(totalAlerts);
    setIsGifAlert(is_gif_alert);
  };
  const getActiveUsers = async () => {
    const { data } = await getActiveUserOrganisation();
    let options = data?.map((item) => ({ label: `${item.name} (${item.email})`, value: item }));
    setShareUserOptions(options);
  };
  const handleEmailAlert = () => {
    setIsEmailAlert(!isEmailAlert);
  };
  const updateEmailAlertHandler = async () => {
    if (props.selectedTempData) {
      let payload = {
        search_name: props.selectedTempData.search_name,
        is_email_alert: isEmailAlert,
        frequency: Number(frequency),
        alert_entity: alertEntity.map((item) => item.value),
        measurable_parameters: measurableParameter,
        country: props.selectedTempData.country,
        trade_direction: props.selectedTempData.trade_direction,
        product_id: props.selectedTempData.product_id ? props.selectedTempData.product_id : "",
      };
      const response = await updateEmailAlert(payload);
      if (response.status === "success") {
        toast.success(response.message);
        if (props.handleClose) {
          setStep(1);
          props.getDashboardData();
          props.handleClose();
        }
      } else {
        toast.error("Something went wrong. Please try again later!!!");
      }
    } else {
      toast.error("Something went wrong. Please try again later!!!");
    }
  };
  const saveSearch = async () => {
    if (totalAlerts[saveSearchName] !== undefined && totalAlerts[saveSearchName].toString() && !props.isDashboard) {
      return toast.error("Given name to the search already exists for you, please rename to continue.");
    }
    if (!isEmailAlert && isGifAlert && step === 1 && !props.isDashboard && !((props && props?.currentPlan && props.currentPlan === upgradePlansDictionary.trademo_intel_us_pro2.key) || (props?.currentPlanAccess && props?.currentPlanAccess?.is_email_alert === false))) {
      trademoTrackingEvents(trackingEventDictionary.shipmentsPageSaveSearchSave, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
      const { redirectingCompanyName, redirectionHsCodeValue, redirectingProfileName } = props;
      if (!(!!redirectingCompanyName && redirectingCompanyName !== "") && props?.type !== "bol" && !(!!redirectionHsCodeValue && redirectionHsCodeValue !== "") && !(redirectingProfileName && redirectingProfileName !== "")) {
        return setStep(2);
      }
    }
    if (props.isDashboard) {
      if (props.currentTab === TABENUM.current) {
        if (props.isDashboard && step === 1 && !!props.selectedTempData && !!props.selectedTempData.is_email_alert && !!isEmailAlert) {
          trademoTrackingEvents(trackingEventDictionary.dashboardSavedSearchesEditEmailAlertUpdateAlert, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
        } else {
          trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistorySetSavedSearchEmailAlert, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
        }
      } else if (props.currentTab === TABENUM.shared) {
        if (props.isDashboard && step === 1 && !!props.selectedTempData && !!props.selectedTempData.is_email_alert && !!isEmailAlert) {
          trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistorySetSavedSearchEmailAlertSharedWithMe, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
        } else {
          trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistoryEditEmailAlertUpdateAlertSharedWithMe, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
        }
      }

      return updateEmailAlertHandler();
    }
    if (step === 1) {
      const { redirectionHsCodeValue } = props;
      const eventName = !!redirectionHsCodeValue && redirectionHsCodeValue.length > 0 ? trackingEventDictionary.hsCodeRedirectionShipmentsPageSaveSearchSave : trackingEventDictionary.shipmentsPageSaveSearchSaveSetEmailAlert;
      trademoTrackingEvents(eventName, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
    } else {
      trademoTrackingEvents(trackingEventDictionary.shipmentsPageSaveSearchSkipAndSave, generateTrackingObject(props.analyticsCountryID, window.location.pathname, props.currentUserPlan));
    }
    if (saveSearchName) {
      const requestObject = {
        search_phrase: !!props && !!props.searchString ? props.searchString : "",
        search_category: !!props && !!props.searchKey ? props.searchKey : "",
        search_type: !!props && !!props.queryType ? props.queryType : "",
        search_name: saveSearchName || "",
        country: !!props && !!props.country && props.country !== "" ? props.country.toUpperCase() : "",
        trade_direction: !!props && !!props.tradeDirection && props.tradeDirection !== "" ? props.tradeDirection.toUpperCase() : "",
        is_email_alert: isEmailAlert,
        frequency: frequency ? parseInt(frequency) : null,
        url: props.redirectingCompanyName ? "" : !!props && !!props.redirectionId && props.redirectionId !== "" ? getIntelUrl() + redirectionUrls[props.redirectionId] : "",
        product_id: !!props && !!props.productId && props.productId !== "" ? props.productId : "",
        search_data: JSON.parse(JSON.stringify(props.savedSearchRequestObject)),
        is_shared: selectedShareUser && selectedShareUser?.length > 0 ? true : false,
        shared_with: selectedShareUser?.length > 0 && selectedShareUser?.map((user) => user.value),
        date_range: selectedDateRange?.value?.includes("Custom") ? selectedDateRange.value.split(": ")[1] : (selectedDateRange?.value ?? ""),
        is_shared_from_save_search: true,
      };
      if (!!props.savedSearchRequestObject && !!props.savedSearchRequestObject.weight && props.savedSearchRequestObject.weight.length > 0 && !props.showNewWeightFilter) {
        requestObject.search_data["weight"] = props.savedSearchRequestObject.weight.map((data) => (WeightArray[data] ? WeightArray[data] : data));
      }
      if (!!props.savedSearchRequestObject && !!props.savedSearchRequestObject.teu && props.savedSearchRequestObject.teu.length > 0) {
        requestObject.search_data["teu"] = props.savedSearchRequestObject.teu.map((data) => (TeuArray[data] ? TeuArray[data] : data));
      }
      if (!!props.searchType && props.searchType.toLowerCase() === "basic") {
        requestObject.search_key = !!props && !!props.searchType && props.searchType !== "" && props.searchType.toLowerCase() === "basic" ? "Primary" : "";
        requestObject.search_data.search = props.searchString;
        requestObject.search_data.key = props.searchKey;
        requestObject.search_data.queryType = props.queryType;
      }
      if (!!props.isRedirect || (!!props.redirectingCompanyName && props.redirectingCompanyName !== "") || (!!props.redirectionHsCodeValue && props.redirectionHsCodeValue !== "")) {
        requestObject.source = "redirection";
        requestObject.url = window.location.search;
      }
      requestObject.measurable_parameters = measurableParameter;
      requestObject.alert_entity = alertEntity.map((item) => item.value);
      const response = await saveSearchCall(requestObject);
      if (response.status === "success") {
        toast.success(`"${saveSearchName ?? "Search"}" has been added to your Saved Searches.`);
        setStep(1);
        checkEmailAlertHandler();
        handleModalClose();
      } else {
        toast.error(response.message);
      }
    } else {
      toast.error("Please Enter Search Name");
    }
  };
  const onChangeHandler = (val) => {
    if (!!val && !!val.length) {
      if (val.length <= 5) setAlertEntity(val);
    } else {
      setAlertEntity([]);
    }
  };

  return (
    <div>
      {!props.isDashboard && (
        <div className="tw-flex tw-gap-1 tw-items-center tw-cursor-pointer">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5a1ce2">
              <path d="M820-671.54v459.23Q820-182 799-161q-21 21-51.31 21H212.31Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h459.23L820-671.54ZM479.91-269.23q41.63 0 70.86-29.14Q580-327.51 580-369.14q0-41.63-29.14-70.86-29.14-29.23-70.77-29.23-41.63 0-70.86 29.14Q380-410.95 380-369.32q0 41.63 29.14 70.86 29.14 29.23 70.77 29.23ZM255.39-564.62h328.45v-139.99H255.39v139.99Z" />
            </svg>
          </div>
          <span className="tw-text-sm tw-font-medium tw-text-primary-purple-600" onClick={handleModalOpen}>
            Save Search
          </span>
        </div>
      )}

      <Modal
        title={step === 1 && !props?.isDashboard ? <span>Save Search</span> : props?.isDashboard && !props?.selectedTempData?.is_email_alert ? "Set email alert " : props?.isDashboard && props?.selectedTempData?.is_email_alert ? "Edit email alert" : "Are you sure, you don't want to receive email alerts for this search?"}
        onClose={handleModalClose}
        isOpen={isModalOpen}
        size={props?.size || "large"}
        footerComponent={
          step === 1 ? (
            <div>
              <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => handleModalClose(step === 1 ? "Cancel" : "Set Email Alert")}>
                {step === 1 ? "Cancel" : "Set Email Alert"}
              </button>
              <button type="button" className="btn btn-primary btn-sm trademo-new-btn" disabled={(saveSearchName.length === 0 && isEmailAlert === false) || (isEmailAlert === true && (!frequency || !measurableParameter.length || !alertEntity.length)) || (!!props.isDashboard && !isEmailAlert && !props.selectedTempData?.is_email_alert) ? true : false} onClick={() => saveSearch()}>
                {step === 1 && !props.isDashboard ? (isEmailAlert ? "Save Search & Set Email Alert" : "Save Search") : !!props.isDashboard && !!props.selectedTempData.is_email_alert && !isEmailAlert ? "Disable Email Alert" : !!props.isDashboard && !!props.selectedTempData.is_email_alert ? "Update Email Alert" : !!props.isDashboard && !props.selectedTempData.is_email_alert ? "Set Email Alert" : "Skip and Save"}
              </button>
            </div>
          ) : (
            <div>
              <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" disabled={(saveSearchName.length === 0 && isEmailAlert === false) || (isEmailAlert === true && (!frequency || !measurableParameter.length || !alertEntity.length)) || (!!props.isDashboard && !isEmailAlert && !props.selectedTempData?.is_email_alert) ? true : false} onClick={() => saveSearch()}>
                {step === 1 && !props.isDashboard ? (isEmailAlert ? "Save Search & Set Email Alert" : "Save Search") : !!props.isDashboard && !!props.selectedTempData.is_email_alert && !isEmailAlert ? "Disable Email Alert" : !!props.isDashboard && !!props.selectedTempData.is_email_alert ? "Update Email Alert" : !!props.isDashboard && !props.selectedTempData.is_email_alert ? "Set Email Alert" : "Skip and Save"}
              </button>
              <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={() => handleModalClose(step === 1 ? "Cancel" : "Set Email Alert")}>
                {step === 1 ? "Cancel" : "Set Email Alert"}
              </button>
            </div>
          )
        }>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <img src={LoaderImg} width={48} height={48} alt="Loading..." />
          </div>
        ) : step === 1 ? (
          <div className={`${styles.save_search_container} saved-search-modal`}>
            {!props?.isDashboard && (
              <div className={styles.left_section}>
                <div className={styles.category_container}>
                  <div className={styles.category_title}>Search Category</div>
                  <div className={styles.pill_container}>
                    <span className={styles.pill_label}>{main_dropdown_options[props.searchKey]}</span>
                  </div>
                </div>
                <div className={styles.category_container}>
                  <div className={styles.category_title}>Search Phrase</div>
                  <div className={styles.pill_container}>
                    {props?.searchString?.split("||").map((item) => (
                      <span className={styles.pill_label} key={item}>
                        {item || "NA"}
                      </span>
                    ))}
                  </div>
                </div>
                <div className={styles.category_container}>
                  <div className={styles.category_title}>Date Range</div>
                  <div className={styles.pill_container}>
                    <span className={styles.pill_label}>{selectedDateRange?.value?.includes("Custom") ? selectedDateRange.value.split(": ")[1] : (selectedDateRange?.value ?? "")}</span>
                  </div>
                </div>
                <div className={styles.category_container}>
                  <div className={styles.category_title}>Applied Filters</div>
                  <div className={styles.pill_container}>
                    {props.filterList && checkforFilters(props.appliedState, props.appliedBooleanFilterObject) ? (
                      <div className={styles.filter_container}>
                        {props.filterList.map((item) => (
                          <React.Fragment key={item.type + item.key}>
                            {props.filterType && item.type === props.filterType.radioFilter && !props.appliedState.include_master_bill ? (
                              <div className="mt-2" data-tip={props.appliedState.include_master_bill ? "Exclude" : hasOwn(props.appliedState, "is_enriched_data") ? (props.appliedState.is_enriched_data ? "Complete Bills of Lading" : "Partial & Complete Bill of Lading") : "Include"} data-for="datatipID">
                                {item.label}1<span className="ml-2 grey-pill">1</span>
                              </div>
                            ) : !!item && props.appliedState && props.appliedState[item.key] && props.appliedState[item.key].length > 0 ? (
                              <div className={styles.filter_section} data-tip={props.appliedState[item.key].map((item) => (item.toString().includes("$$") ? item.split("$$")[0] : item.range ? item.key.toLowerCase() + ": " + commaFormat(item.range[0]) + " to " + commaFormat(item.range[1]) : item)).join(", ")} data-for="datatipID">
                                <span className={styles.filter_label}>{item.label}:</span>
                                <span className={styles.pill_label}>
                                  {props.appliedState[item.key].length}
                                  {props.includeFilter.includes(item.key) ? " Included" : props.excludeFilter.includes(item.key) ? " Excluded" : ""}
                                </span>
                              </div>
                            ) : !!item && props.appliedState && props.appliedState[item?.additionalKey] && props.appliedState[item?.additionalKey].length > 0 ? (
                              <div className={styles.filter_section} data-tip={props.appliedState[item?.additionalKey].map((filterDataItem) => (filterDataItem.toString().includes("$$") ? filterDataItem.split("$$")[0] : filterDataItem.range ? filterDataItem.key.toLowerCase() + ": " + commaFormat(filterDataItem.range[0]) + " to " + commaFormat(filterDataItem.range[1]) : filterDataItem)).join(", ")} data-for="datatipID">
                                <span className={styles.filter_label}>{item.label}:</span>
                                <span className={styles.pill_label}>
                                  {props.appliedState[item?.additionalKey].length}
                                  {props.includeFilter.includes(item?.additionalKey) ? " Included" : props.excludeFilter.includes(item?.additionalKey) ? " Excluded" : ""}
                                </span>
                              </div>
                            ) : (
                              <></>
                            )}
                          </React.Fragment>
                        ))}
                        <ReactTooltip className="trademo-tooltip text-no-transform" textColor="#FFFFFF" place="top" id="datatipID" />
                      </div>
                    ) : (
                      "No filters have been added"
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className={`${styles.right_section} ${props?.isDashboard && "w-100"}`}>
              {!props.isDashboard && (
                <>
                  <div className={styles.category_container}>
                    <div className={styles.category_title}>Add a name to this search</div>
                    <input className={styles.input_field} type="text" placeholder="Enter name for search" value={saveSearchName} onChange={(e) => setSaveSearchName(e.target.value)} />
                  </div>
                  <div className={styles.category_container}>
                    <div className={styles.category_title}>Select a date range for specific</div>
                    <Select styles={searchTypeCustomStyles} options={dateRangeOptions} onChange={(value) => setSelectedDateRange(value)} value={selectedDateRange} placeholder="Select Date Range" menuPosition="fixed" />
                  </div>
                  {shareUserOptions && shareUserOptions.length > 0 && (
                    <div className={styles.category_container}>
                      <div className={styles.category_title}>Share the search with your team</div>
                      <CheckboxSelect options={shareUserOptions} placeholder="Select users from the list. You can select multiple" className="match-type" onChange={(value) => setSelectedShareUser(value || [])} value={selectedShareUser} maxSelection={shareUserOptions?.length ?? 0} />
                    </div>
                  )}
                </>
              )}
              <div className={`${styles.category_container} ${styles.no_gap}`}>
                <div className={styles.category_title}>
                  Would you like to receive email alerts on the search
                  <label className="switch form-check-label mx-2">
                    <input type="checkbox" onChange={handleEmailAlert} checked={isEmailAlert} />
                    <span className="slider round" />
                  </label>
                </div>
                <span className={` ${styles.category_label}`}>Turn on email alerts to get actionable insights on-the-go.</span>
              </div>
              {isEmailAlert && (
                <>
                  <div className={styles.category_container}>
                    <div className={styles.category_title}>How frequently would you like to receive the alerts?</div>
                    <div className={styles.frequency_container}>
                      {frequencyOptions && frequencyOptions[props.redirectionId] && frequencyOptions[props.redirectionId].alert_type
                        ? frequencyOptions[props.redirectionId].alert_type.map((item, index) => {
                            return (
                              <span className={styles.frequency_options} key={index}>
                                <input checked={Number(frequency) === Number(item.value) ? true : false} onChange={(e) => setFrequency(e.target.value)} value={item.value} name="frequency" type="radio" />
                                <span className="unit-label-value">{item.label}</span>
                              </span>
                            );
                          })
                        : ""}
                    </div>
                  </div>
                  <div className={styles.category_container}>
                    <div className={styles.category_title}>Select all that you want to track via this email alerts</div>
                    <div>{frequencyOptions?.[props.redirectionId] && frequencyOptions?.[props.redirectionId]?.analytics_keys ? <CheckboxSelect options={Object.keys(frequencyOptions[props.redirectionId].analytics_keys).map((item) => ({ value: item, label: frequencyOptions[props.redirectionId].analytics_keys[item] }))} placeholder="Select entities from the list. You can select multiple" className="match-type" onChange={onChangeHandler} value={alertEntity} maxSelection={5} /> : <></>}</div>
                  </div>
                  <div className={styles.category_container}>
                    <div className={styles.category_title}>Select measurement unit bases which you want to generate results.</div>
                    <div className={styles.frequency_container}>
                      {frequencyOptions && frequencyOptions[props.redirectionId] && frequencyOptions[props.redirectionId].measurable_parameters
                        ? frequencyOptions[props.redirectionId].measurable_parameters.map((item, index) => (
                            <span className={styles.frequency_options} key={index}>
                              <input checked={measurableParameter[0] && measurableParameter[0] === item ? true : false} onChange={(e) => setMeasurableParameter([e.target.value])} value={item} name="measurement" type="radio" />
                              <span className="unit-label-value">{measurable_parameter_name(item)}</span>
                            </span>
                          ))
                        : ""}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          step === 2 && (
            <div>
              <p>Our email alert feature will keep you updated on new shipments for this saved search, with actionable insights and new trends.</p>
              <div className="text-center">
                <img className="email-alert-gif" alt="email alert" src={"https://res.cloudinary.com/drzta9shk/image/upload/v1680677566/intel/Emails/Final-Landscape-Email-Alerts_ej0wnj.gif"} />
              </div>
            </div>
          )
        )}
      </Modal>
    </div>
  );
};

export default SaveSearch;
